import React from 'react';
import '../../styles/livro.css';

interface LivroCardProps {
  titulo: string;
  descricao: string;
  imagem: string;
  linkCompra?: string;
  invertido?: boolean;
}

const LivroCard: React.FC<LivroCardProps> = ({ titulo, descricao, imagem, linkCompra, invertido }) => {
  return (
    <div className={invertido ? 'livro-card-invertido' : 'livro-card'}>
      <img src={imagem} alt={titulo} className="livro-imagem" />
      <div className="livro-texto">
        <h3>{titulo}</h3>
        <p>{descricao}</p>
        {linkCompra && (
          <button
            className="buy-button"
            onClick={() => window.open(linkCompra, "_blank", "noopener noreferrer")}
          >
            Onde comprar
          </button>
        )}
      </div>
    </div>
  );
};

export default LivroCard;
